import { useMutation } from '@tanstack/react-query';
import reports from 'apis/reports';
import { MutationConfig, DatasetDownloadJobDto } from 'types';

interface CreateDownloadJobOptions {
  reportOrderIds: string;
  format?: string;
  signal?: AbortSignal;
}

export const createDownloadJob = ({ reportOrderIds, format, signal }: CreateDownloadJobOptions) => {
  const formatParam = format ? `&targetFormat=${format}` : '';
  return reports.post<DatasetDownloadJobDto>(`/datasets/download-job?ids=${reportOrderIds}${formatParam}`, null, {
    signal,
  });
};

interface UseCreateDownloadJobOptions {
  mutationConfig?: MutationConfig<typeof createDownloadJob>;
}

export const useCreateDownloadJob = ({ mutationConfig }: UseCreateDownloadJobOptions = {}) => {
  const config = mutationConfig || {};

  return useMutation({
    ...config,
    mutationFn: createDownloadJob,
  });
};
